import ReactHtmlParser from "react-html-parser";

export default (sopParameters) => ReactHtmlParser(
  `<div>
  <h2>AMXL Prf Picking Not Yet Picked</h2>
  <h3>Description</h3>
  <p>This exception is raised when a shipment item is close to its CPT while in a Rodeo work pool state of 'Picking Not Yet Picked' thus at risk of becoming rolled freight</p>
  <h3>SOP</h3>
  <ul>
    <li>Check if pick is in NonPickable bucket
      <ul>
        <li>Yes, move to step #3</li>
        <li>No, move to step #2</li>
      </ul>
    </li>
    <li>Check if pick is in a picker's in scanner queue
      <ul>
        <li>Yes, engage picker to bring at risk pick to problem solve area when picked</li>
        <li>No, move to step #3</li>
      </ul>
    </li>
    <li>Check in shipment as dwelling</li>
    <li>Process through send runner process</li>
    <li>Pack from POPS shipment</li>
    <li>SLAM unit and immediately load on appropriate pallet/trailer</li>
  </ul>
</div>`
);



// WEBPACK FOOTER //
// ./src/components/taskExecution/TaskSOP/FallbackSOPWiki/AMXL_PRF_PICKING_NOT_YET_PICKED.jsx